// extracted by mini-css-extract-plugin
export default {"floatingCircle":"FloatingCircle_floatingCircle__Z9w-H"};